import { render } from "./FloatingComponent.vue?vue&type=template&id=40ae45c4&scoped=true"
import script from "./FloatingComponent.vue?vue&type=script&lang=js"
export * from "./FloatingComponent.vue?vue&type=script&lang=js"

import "./FloatingComponent.vue?vue&type=style&index=0&id=40ae45c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ae45c4"]])

export default __exports__